// play() resolves only once the browser actually starts the recording. Keep
// the replay clock stopped while media is loading, and ignore late results
// after a pause, close, version change, or unmount.
export function scheduleReplayAudioStart(audio, { onStarted, onError, onAutoplayBlocked }) {
  let cancelled = false
  async function start() {
    try {
      if (audio.error) audio.load()
      await audio.play()
    } catch (error) {
      if (cancelled) return
      // Browser autoplay policy is not a failed recording. Leave the player
      // paused until a click can start audible playback.
      if (error.name === "NotAllowedError") onAutoplayBlocked()
      else onError(error)
      return
    }
    if (!cancelled) onStarted()
  }
  // Call play() in the click's user activation, before any timer can lose it.
  start()

  return () => {
    cancelled = true
    audio.pause()
  }
}
